// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"453":"rum-client-open-telemetry-api","823":"rum-client-faro","906":"rum-client-tracing"}[chunkId] || chunkId) + ".chunk.js";
};